import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { tap } from 'rxjs/operators';

import { lendingTypes } from '@shared/constants/lending-types';
import { LendingType } from '@shared/models/lending-type';
import { LendingTypeService } from '@shared/services/lending-type.service';
import { UtilsService } from '@shared/services/utils.service';

export const lendingTypeResolver: ResolveFn<LendingType[]> =
  (route: ActivatedRouteSnapshot) => {
    const lendingTypeService = inject(LendingTypeService);
    const utilsService = inject(UtilsService);

    return lendingTypeService.getLendingTypes().pipe(
      tap((types: LendingType[]) => {
        lendingTypeService.lendingTypes = types;
        lendingTypeService.lendingType =
          types.find((x) => x.id === +utilsService.routeParams(route).lendingTypeId
            || x.code.toUpperCase() === utilsService.routeParams(route).lendingType?.toUpperCase(),
          ) ??
          types.find((t) => t.code === lendingTypes.residential);
      }),
    );
  };
